import React from 'react';
import Footer from "./Footer";

function ContactUs() {
  return (
    <>
    <div className="contact-us-page">
      <h1 className="contact-header">Contact Us</h1>
      <div className="contact-container">
        <div className="contact-details">
          <h2>Get in Touch</h2>
          <p><strong>Address:</strong> X Vector Technologies Pvt. Ltd., Behind Moze College, Merrygold Lane, Blossom Rd, Laxman Nagar, Baner, Pune, Maharashtra 411045</p>
          <p><strong>Email:</strong> <a href="mailto:sales@xvectortechnologies.com">sales@xvectortechnologies.com</a></p>
          <p><strong>Phone:</strong> <a href="tel:+919011000452">+91-9011000452</a></p>
          <p><strong>Working Hours:</strong> Monday - Saturday, 9:00 AM - 6:00 PM</p>
        </div>
        <div className="map-section">
          <h2>Find Us Here</h2>
        <iframe
          title="X Vector Technologies Location Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d945.5080123928218!2d73.76875266944299!3d18.57259377016992!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b9bde3c7a1bd%3A0x7c42b8c423ed6856!2sX%20Vector%20Technologies%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1735812759670!5m2!1sen!2sin"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
}

export default ContactUs;